import React from 'react'
import {ColorCircle, Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {EVENTS_ROUTES} from '../../constants'
import {useCurrentEventCounts} from '@src/modules/Events/hooks/useCurrentEventCounts'
import {MdBolt} from 'react-icons/md'

function EventsMobileMenuLink() {
  const {counts} = useCurrentEventCounts()

  let notificationColor: 'main' | 'caution' | undefined
  if (counts.active) {
    notificationColor = 'main'
  } else if (counts.pending) {
    notificationColor = 'caution'
  }

  return (
    <MobileMenuLink to={EVENTS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <div className="relative">
          <Icon Icon={MdBolt} />

          {!!notificationColor && (
            <div className="absolute -right-0.5 -top-2">
              <ColorCircle size="sm" variant={notificationColor} />
            </div>
          )}
        </div>
        <span>Events</span>
      </div>
    </MobileMenuLink>
  )
}

export {EventsMobileMenuLink}
